module.exports = __webpack_public_path__ + "static/media/ticketActive.399a0e38.svg";